<template>
  <div style="text-align: center;">
    <p v-html="$sanitize(getTitle)"></p>
    <p v-if="show_confirmation_text"><b>בטוח למחוק?</b></p>
    <div class="is-flex is-align-items-center is-justify-content-center" style="margin-top: 30px; border-top: 1px solid rgba(0, 0, 0, 0.1); padding-top: 30px;">
      <a @click="deleteAndRefresh()" class="button is-danger">כן ורענן לי את הדף</a>
      <div style="width: 10px"></div>
      <a @click="deleteWithoutRefresh()" class="button is-danger">כן ואל תרענן</a>
      <div style="width: 10px"></div>
      <a @click="close()" class="button is-info">לא, בטל</a>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'delete-prompt',
  props: ['payload'],
  data () {
    return {
      show_confirmation_text: this.payload.show_confirmation_text == undefined ? true : this.payload.show_confirmation_text
    }
  },
  computed: {
    getTitle () {
      if (this.payload.prompt_title != undefined) {
        return this.payload.prompt_title
      }
      return `את/ה בדרך למחוק את ${this.payload.item_name}`
    }
  },
  methods: {
    deleteAndRefresh () {
      let query = { ...this.$route.query }
      query.refresh_toggle = !query.refresh_toggle
      this.makeRequest().then(() => {
        this.$router.push({ name: this.$route.name, query: query })
      })
    },
    deleteWithoutRefresh () {
      this.makeRequest().then(() => {
        if (this.payload.refresh) {
          this.payload.refresh()
        }
        this.close()
      })
    },
    close () {
      this.remove(this.payload)
    },
    makeRequest () {
      return this.$network_utils[this.payload.method](this.payload.method_params)
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
